import React, { Component } from 'react';
import axios from 'axios';
import '../css/AdminList.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import  { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';



export default class AdminList extends Component
{
   constructor(props) {
      super(props);
      this.state ={
        products: [],
        isHacker: false

      }
    }

    componentDidMount() {
        if (localStorage.getItem('token') !== localStorage.getItem('existToken') || localStorage.getItem('existToken') === null){
            this.setState({ 
                isHacker:true
            });
        }
        this.eGetList();
    }

    eGetList() {
        axios.get(`https://ikaemerce.faisalhakim.com/apilaravel/public/api/products`)
        .then(res => {
          const products = res.data;
          this.setState({ 
            products:products });
      })
    }
    

    eDelete(id,e) {
        e.preventDefault();
        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure to do this.',
            buttons: [
              {
                label: 'Yes',
                onClick: () => 
                    axios.delete(`https://ikaemerce.faisalhakim.com/apilaravel/public/api/products/`+id)
                    .then(res => {
                        toast("Successfully Deleted ");
                        this.setState({ 
                            products:res.data
                        });
                    })
                    .catch(function (error) {
                        if (error.response) {
                          // Request made and server responded
                          toast("Failed, "+error.response.data.message);
                        } else if (error.request) {
                          // The request was made but no response was received
                         toast("Failed, "+error.request);
                        } else {
                          // Something happened in setting up the request that triggered an Error
                          toast('Failed, ', error.message);
                        }
                      })
                    
              },
              {
                label: 'No'
              }
            ]
        });
    }

    Logout = (e) => {
        localStorage.setItem('existToken','numbersoftoken');
        localStorage.setItem('token','');
    }

  
   render()
   {
    return (
      <div className="adminList container">
        {this.state.isHacker ? <Redirect to="/login" /> : ""}
        <h1>IKAEMERCE Product List</h1>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-6 text-left">
            <Link to="/admin/new" className="btn btn-primary btn-sm">
              {" "}
              New Product
            </Link>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
            <a
              type="button"
              href="https://ikaemerce.faisalhakim.com"
              className="btn btn-success btn-sm"
              onClick={(e) => this.Logout(e)}
            >
              {" "}
              Go to Website{" "}
            </a>
          </div>
        </div>
        <table className="table table-striped table-hover table-responsive-lg ">
          <thead className="thead-warning">
            <tr>
              <th>No</th>
              <th>Category</th>
              <th>Title</th>
              {/* <th>Description</th> */}
              <th>Price</th>
              <th>Availability</th>
              <th>Picture</th>
              <th style={{ width: 8 + "%" }}>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {this.state.products.map((products, index) => (
              <tr key={products.id}>
                <td>{index + 1}</td>
                <td>{products.category}</td>
                <td>{products.title}</td>
                {/* <td>
                            {products.description}
                        </td> */}
                <td>{products.price}</td>
                <td>{products.availability === "1" ? "Yes" : "No"}</td>
                <td>
                  <img
                    src={"https://ikaemerce.faisalhakim.com/apilaravel/public/api/image/" + products.filename}
                    className="img-fluid"
                    alt=""
                  />
                </td>
                <td>
                  <Link to={"/admin/edit?id=" + products.id}>
                    <i className="fa fa-pencil-square-o" aria-hidden="true" title="Edit"></i>
                  </Link>
                  &emsp;
                  <i
                    className="fa fa-remove"
                    aria-hidden="true"
                    title="Delete"
                    onClick={(e) => this.eDelete(products.id, e)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
   }
}